import { RouterOutputs, trpc } from "../trpc";

export type Account = RouterOutputs["account"]["account"];

interface Input {
  enabled?: boolean;
}

export function useAccount(input?: Input) {
  const { enabled = true } = input || {};

  const {
    data: account,
    isLoading,
    isPending,
  } = trpc.account.account.useQuery(undefined, { enabled });

  return {
    account,
    isLoading,
    isPending,
  };
}
